export default [
    {
        path: '/report/daily-water-wales',
        name: "DailyWaterSales",
        meta: {authRequired: true},
        component: () => import('../views/report/daily-water-sales'),
    },

    {
        path: '/report/tara-dynamics',
        name: "TaraDynamics",
        meta: {authRequired: true},
        component: () => import('../views/report/tara-dynamics'),
    },
    {
        path: '/report/driver-orders',
        name: 'DriverOrders',
        meta: {authRequired: true},
        component: () => import("../views/report/driver-reports/order-delivery"),
    }
]
